import React from "react";
import Section from "./Section";

export default function Slider() {
  return (
    <Section id={"home"} className={"ud-hero"}>
      <div className="row">
        <div className="col-lg-12">
          <div className="ud-hero-content wow fadeInUp" data-wow-delay=".2s">
            <h1 className="ud-hero-title">
              Site/Apartman Yönetmek <br />
              Artık Daha Kolay
            </h1>
            <p className="ud-hero-desc">
              Aidat+ ile siz de sitenizi veya apartmanınızı daha etkili ve hızlı
              yönetebilir, dairelerinize kolaylık sağlayabilirsiniz.
            </p>
            <ul className="ud-hero-buttons">
              <li>
                <a
                  href="https://app.aidatplus.space/register"
                  rel="nofollow noopener"
                  target="_blank"
                  className="ud-main-btn ud-white-btn"
                >
                  Başvur
                </a>
              </li>
              <li>
                <a
                  href="/about"
                  rel="nofollow noopener"
                  className="ud-main-btn ud-link-btn"
                >
                  Daha Fazla <i className="lni lni-arrow-right"></i>
                </a>
              </li>
            </ul>
          </div>
          {/* <div
          className="ud-hero-brands-wrapper wow fadeInUp"
          data-wow-delay=".3s"
        >
          <img src="assets/images/hero/brand.svg" alt="brand" />
        </div> */}
          <div className="ud-hero-image wow fadeInUp" data-wow-delay=".25s">
            <img src="assets/images/hero/hero-image.jpg" alt="hero-image" />
            <img
              src="assets/images/hero/dotted-shape.svg"
              alt="shape"
              className="shape shape-1"
            />
            <img
              src="assets/images/hero/dotted-shape.svg"
              alt="shape"
              className="shape shape-2"
            />
          </div>
        </div>
      </div>
    </Section>
  );
}
